"use strict";
/** The model for a given field's data elements */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @param {ViewModel} object
 */
function instanceOfInputViewModel(object) {
    return 'value' in object;
}
exports.instanceOfInputViewModel = instanceOfInputViewModel;
/**
 * @param {ViewModel} object
 */
function instanceOfListViewModel(object) {
    return 'items' in object;
}
exports.instanceOfListViewModel = instanceOfListViewModel;
